import Cookies from 'universal-cookie';
import { create } from 'zustand';
const cookies = new Cookies();

const initialState = {
  token: cookies?.get('token'),
  roleId: cookies?.get('roleId'),
  roleName: cookies?.get('roleName'),
  userId: cookies?.get('userId'),
  organization: cookies?.get('organization'),
  accessPermission: localStorage?.getItem('accessPermission'),
  isLoadingUser: true,
  brands: cookies?.get('brands'),
};

const resetState = {
  token: null,
  roleId: null,
  roleName: null,
  userId: null,
  organization: null,
  accessPermission: null,
  isLoadingUser: null,
  brands: null,
};

export const useUserInfo = create((set) => ({
  ...initialState,
  onChangeUserInfo: (newState) => set((state) => ({ ...state, ...newState })),
  onResetUserInfo: () => set(() => ({ ...resetState })),
}));
